export const API_GET_ALL_PROVIDER = "/admin/proveedores/";
export const API_GET_SEARCH_PROVIDERS = "/admin/proveedores/buscar/";
export const API_PUT_UPDATE_PROVIDERS = "/admin/proveedores/actualizar-proveedor/";
export const API_POST_SAVE_PROVIDERS = "/admin/proveedores/registro-proveedor";